import React from 'react';
import { PlayCircleIcon } from 'lucide-react';
export function Hero() {
  return <section className="text-center pt-8" data-id="element-128">
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-3 leading-tight mx-auto max-w-4xl" data-id="element-129">
        <span className="font-light" data-id="element-130">Descubre el sistema</span> que marcas DTC
        de 8 y 9 cifras llaman su{' '}
        <span className="text-orange-400" data-id="element-131">'arma secreta'</span>
      </h1>
      <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-4 text-orange-300 mx-auto max-w-3xl" data-id="element-132">
        prompts de IA que convierten cualquier funnel en una máquina de ventas
        predecible — en solo 4 semanas.
      </h2>
      <div className="relative mb-2 max-w-3xl mx-auto" data-id="element-133">
        <div className="aspect-video bg-gray-800 rounded-lg flex items-center justify-center shadow-lg" data-id="element-134">
          <div className="text-center" data-id="element-135">
            <PlayCircleIcon className="h-20 w-20 text-orange-500 mx-auto mb-4" data-id="element-136" />
            <p className="text-lg font-medium" data-id="element-137">Ver presentación completa</p>
          </div>
        </div>
      </div>
    </section>;
}